
import React from 'react';
import { SystemConfig } from '../../types';
import { Rocket, ShieldCheck, AlertCircle } from 'lucide-react';

interface Props {
  config: SystemConfig;
  setConfig: (config: SystemConfig) => void;
}

export const SettingsTabDeploy: React.FC<Props> = ({ config, setConfig }) => {
  const isReadyForProduction = config?.googleMapsApiKey && (config?.cardapioWeb?.active || config?.openDelivery);

  return (
    <div className="space-y-6">
      <div className="bg-app-bg p-6 rounded-2xl border border-border-dim">
        <div className="flex items-center gap-3 mb-6">
          <Rocket className="w-5 h-5 text-sal-cyber-teal" />
          <h3 className="text-base font-black text-text-primary uppercase tracking-widest">Status de Implementação</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className={`p-4 rounded-xl border flex items-start gap-3 shadow-sm ${config?.googleMapsApiKey ? 'bg-status-ready/5 border-status-ready/20' : 'bg-status-critical/5 border-status-critical/20'}`}>
            {config?.googleMapsApiKey ? <ShieldCheck className="w-5 h-5 text-status-ready shrink-0" /> : <AlertCircle className="w-5 h-5 text-status-critical shrink-0" />}
            <div>
              <p className="text-xs font-black text-text-primary uppercase mb-1">Google Maps API</p>
              <p className="text-xs text-text-muted">{config?.googleMapsApiKey ? 'Configurada e pronta.' : 'Necessária para o cérebro logístico.'}</p>
            </div>
          </div>

          <div className={`p-4 rounded-xl border flex items-start gap-3 shadow-sm ${config?.cardapioWeb?.active || config?.openDelivery ? 'bg-status-ready/5 border-status-ready/20' : 'bg-status-pending/5 border-status-pending/20'}`}>
            {config?.cardapioWeb?.active || config?.openDelivery ? <ShieldCheck className="w-5 h-5 text-status-ready shrink-0" /> : <AlertCircle className="w-5 h-5 text-status-pending shrink-0" />}
            <div>
              <p className="text-xs font-black text-text-primary uppercase mb-1">Integração PDV</p>
              <p className="text-xs text-text-muted">{config?.cardapioWeb?.active || config?.openDelivery ? 'Ativa e monitorando.' : 'Nenhuma sincronia automática configurada.'}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-6 rounded-2xl bg-sal-cyber-teal/5 border border-sal-cyber-teal/20">
        <h4 className="text-sm font-black text-sal-cyber-teal uppercase tracking-widest mb-2">Pronto para Produção?</h4>
        <p className="text-xs text-text-muted leading-relaxed">
          {isReadyForProduction
            ? "Sua operação está com todos os requisitos mínimos configurados. O S.A.L. Rota está pronto para otimizar suas rotas reais."
            : "Ainda faltam configurações essenciais para operar em modo profissional. Verifique as abas Google e PDVs."}
        </p>
      </div>
    </div>
  );
};
